/**
 * Auto-generated service - DO NOT EDIT MANUALLY
 * Generated from: organization_user.ts
 * Run: pnpm gen
 */

import { API_METHODS } from '../constants/api-methods';
import { getApiPath } from '../path';
import { type RequestOptions, type Transport } from '../transport';

import type {
  AddOrganizationUserRoleRequest,
  AddOrganizationUserRoleResponse,
  ChangeOrganizationUserRoleRequest,
  ChangeOrganizationUserRoleResponse,
  GetOrganizationUserRolesRequest,
  GetOrganizationUserRolesResponse,
  RemoveOrganizationUserRoleRequest,
  RemoveOrganizationUserRoleResponse,
  SearchOrganizationUsersRequest,
  SearchOrganizationUsersResponse,
} from '../types/organization_user';

export const createOrganizationUserService = (transport: Transport) => ({
  async searchOrganizationUsers(
    request: SearchOrganizationUsersRequest,
    options: RequestOptions = {},
  ): Promise<SearchOrganizationUsersResponse> {
    const { organization_id, ...params } = request;
    const url = getApiPath(API_METHODS.OrganizationUserService.SearchOrganizationUsers, {
      organization_id,
    });
    return transport.get<SearchOrganizationUsersResponse>(url, { params, ...options });
  },

  async getOrganizationUserRoles(
    request: GetOrganizationUserRolesRequest,
    options: RequestOptions = {},
  ): Promise<GetOrganizationUserRolesResponse> {
    const { organization_id, user_id, ...params } = request;
    const url = getApiPath(API_METHODS.OrganizationUserRoleService.GetOrganizationUserRoles, {
      organization_id,
      user_id,
    });
    return transport.get<GetOrganizationUserRolesResponse>(url, { params, ...options });
  },

  async addOrganizationUserRole(
    request: AddOrganizationUserRoleRequest,
    options: RequestOptions = {},
  ): Promise<AddOrganizationUserRoleResponse> {
    const { organization_id, user_id, ...body } = request;
    const url = getApiPath(API_METHODS.OrganizationUserRoleService.AddOrganizationUserRole, {
      organization_id,
      user_id,
    });
    return transport.post<AddOrganizationUserRoleResponse>(url, body, options);
  },

  async removeOrganizationUserRole(
    request: RemoveOrganizationUserRoleRequest,
    options: RequestOptions = {},
  ): Promise<RemoveOrganizationUserRoleResponse> {
    const { organization_id, user_id, ...body } = request;
    const url = getApiPath(API_METHODS.OrganizationUserRoleService.RemoveOrganizationUserRole, {
      organization_id,
      user_id,
    });
    return transport.delete<RemoveOrganizationUserRoleResponse>(url, { data: body, ...options });
  },

  async changeOrganizationUserRole(
    request: ChangeOrganizationUserRoleRequest,
    options: RequestOptions = {},
  ): Promise<ChangeOrganizationUserRoleResponse> {
    const { organization_id, user_id, ...body } = request;
    const url = getApiPath(API_METHODS.OrganizationUserRoleService.ChangeOrganizationUserRole, {
      organization_id,
      user_id,
    });
    return transport.post<ChangeOrganizationUserRoleResponse>(url, body, options);
  },
});

export type OrganizationUserService = ReturnType<typeof createOrganizationUserService>;
